import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入适配组件
import 'amfe-flexible'
// 引入vant框架
import Vant, { Lazyload } from 'vant'
import 'vant/lib/index.less'
// 自定义全局样式
import './styles/index.less'
// 注册自己的组件
import time from './utils/plugin'
// 注册全局的过滤时间
Vue.use(time)
// Vue.prototype.$sleep = la

// 注册懒加载组件
Vue.use(Lazyload)
// 注册组件
Vue.use(Vant)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
